import axios from "axios";
import { AddProjectWishlistApi, ProjectWishlistApi, RemoveProjectWishlistApi } from ".";

export const fetchWishlist = (projectId) => {
  return axios.get(`${ProjectWishlistApi}?project_id=${projectId}`).then((res) => {
    return res.data;
  });
};

export const addWishlistItem = (projectId, productId, variantId) => {
  return axios.post(AddProjectWishlistApi, {
    product_id: productId,
    variant_id: variantId,
    project: projectId,
  }).then((res) => {
    return res.data;
  });
}

export const removeWishlistItem = (projectId, variantId) => {
  return axios.delete(`${RemoveProjectWishlistApi}?project_id=${projectId}&variant_id=${variantId}`).then((res) => {
    return res.data;
  });
};
